/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import { BedTransferApi } from '../api/bedtransfer.api';
import { switchMap, map } from 'rxjs/operators';
import { BedTransferData, BedTransfer } from '../../../interfaces/masters/bedtransfer';

@Injectable()
export class BedTransferService extends BedTransferData {

  constructor(private api: BedTransferApi) {
    super();
  }


  list(url: string): Observable<BedTransfer[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<BedTransfer>{
      return this.api.getById(url);
  }

  create(url: string, data:BedTransfer): Observable<BedTransfer[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:BedTransfer): Observable<BedTransfer> {
    return this.api.update(url,data);
  }

  updateBulkDate(url: string, data:any): Observable<BedTransfer> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
